import http from "infra/http";
import { useQuery } from "react-query";
import { MensagemDetalhe } from "../typings";

function useDetalheMensagem(mensagemId: string, enabled = true) {
  return useQuery(`/v1/mensagem/${mensagemId}`, async () => {
    const { data } = await http.get<MensagemDetalhe>(
      `/v1/mensagem/${mensagemId}`,
    );
    return data;
  }, {
    enabled: !!mensagemId && enabled,
    refetchInterval: 30 * 1000,
  });
}

export default useDetalheMensagem;
